import React from 'react';

function TooltipOverlay(props) {
  const { elementId, row, template, x, y, visible } = props;

  if (!visible || !row || !template || x === null || y === null) {
    return null;
  }

  // Render tooltip text with template substitution
  const renderTooltip = () => {
    let text = template;

    // Replace id placeholder (using both 'id' and 'elementId' for compatibility)
    text = text.replace(/\{\{id\}\}/g, elementId || '');
    text = text.replace(/\{\{elementId\}\}/g, elementId || '');

    // Replace value placeholder
    const value = row.value ?? row.power_kw ?? row.a ?? 'N/A';
    text = text.replace(/\{\{value\}\}/g, value);

    // Replace all other field placeholders
    Object.keys(row).forEach((key) => {
      const placeholder = `{{${key}}}`;
      const fieldValue = row[key];
      if (fieldValue !== undefined && fieldValue !== null) {
        text = text.replace(new RegExp(placeholder, 'g'), fieldValue);
      }
    });

    return text;
  };

  const tooltipText = renderTooltip();

  return (
    <div
      className="tooltip-box"
      style={{
        left: `${x + 15}px`,
        top: `${y + 15}px`,
        display: visible ? 'block' : 'none',
        // Manual override for some props if needed, but classes handle most
        whiteSpace: 'pre-line',
      }}
    >
      {tooltipText.replace(/\\n/g, '\n')}
    </div>
  );
}

export default TooltipOverlay;
